module.exports = __webpack_public_path__ + "assets/img/header.db7d448d.png";